import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Spacer } from '@xing-com/crate-upsell-layouts';
import { IconLockClosed } from '@xing-com/icons';
import { spaceM, spaceXXL } from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';
import { Column, Row } from '@xing-com/xing-grid';

import AmexLogo from '../assets/amex.svg';
import GdprLogo from '../assets/gdpr.svg';
import MasterLogo from '../assets/master.svg';
import PaypalLogo from '../assets/paypal.svg';
import SepaLogo from '../assets/sepa.svg';
import VisaLogo from '../assets/visa.svg';

export const EncryptionNotice: React.FC = () => {
  return (
    <Row>
      <Column size={12}>
        <EncryptionNoticeWrapper>
          <IconLockClosed width={24} height={24} />
          <Spacer $axis="horizontal" $size="spaceS" />
          <BodyCopy size="medium" noMargin>
            <FormattedMessage id="UPSELL_PURCHASE_ENCRYPTION_NOTE" />
          </BodyCopy>
        </EncryptionNoticeWrapper>
      </Column>
    </Row>
  );
};

export const UpsellFooter: React.FC = () => {
  return (
    <UpsellFooterWrapper>
      <Column size={12} sizeConfined={6} sizeXWide={5}>
        <Headline size="large" sizeConfined="xlarge">
          <FormattedMessage id="UPSELL_PURCHASE_PAYMENT_OPTIONS_HEADLINE" />
        </Headline>
        <PaymentOptionsLogos>
          <img src={VisaLogo.toString()} alt="some logo" />
          <img src={MasterLogo.toString()} alt="some logo" />
          <img src={AmexLogo.toString()} alt="some logo" />
          <img src={PaypalLogo.toString()} alt="some logo" />
          <img src={SepaLogo.toString()} alt="some logo" />
        </PaymentOptionsLogos>
      </Column>
      <Spacer $size="spaceXXL" $sizeConfined="spaceNone" />
      <Column size={12} sizeConfined={6} sizeXWide={7}>
        <Row>
          <Column size={12} sizeXWide={5}>
            <Headline size="large" sizeConfined="xlarge">
              <FormattedMessage id="UPSELL_PURCHASE_HELP_CONTACT_HEADLINE" />
            </Headline>
            <BodyCopy
              size="medium"
              sizeConfined="large"
              fontWeight="bold"
              noMargin
            >
              <FormattedMessage id="UPSELL_PURCHASE_HELP_PHONE_CONTACT" />
            </BodyCopy>
            <BodyCopy size="xsmall" noMargin>
              <FormattedMessage id="UPSELL_PURCHASE_HELP_SERVICE_HOURS" />
            </BodyCopy>
            <Spacer $size="spaceM" />
            <BodyCopy size="small" noMargin>
              <FormattedMessage id="UPSELL_PURCHASE_HELP_EMAIL_CONTACT" />
            </BodyCopy>
          </Column>
          <Spacer $size="spaceXXL" $sizeConfined="spaceNone" />
          <Column size={12} sizeXWide={5} offsetXWide={2}>
            <Headline size="large" sizeConfined="xlarge">
              <FormattedMessage id="UPSELL_PURCHASE_PRIVACY_HEADLINE" />
            </Headline>
            <DataProtectionLogo>
              <img src={GdprLogo.toString()} alt="some logo" />
            </DataProtectionLogo>
          </Column>
        </Row>
      </Column>
    </UpsellFooterWrapper>
  );
};

const EncryptionNoticeWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${spaceM} 0;
`;

const UpsellFooterWrapper = styled(Row)`
  padding-top: ${spaceXXL};
  padding-bottom: ${spaceXXL};
`;

const PaymentOptionsLogos = styled.div`
  display: flex;
  gap: ${spaceM};

  & > img {
    min-width: 0;
    flex: 1;
  }
`;

const DataProtectionLogo = styled.div`
  max-width: 150px;
`;
